"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataTable = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".cffcb3f50{width:100%;overflow:auto;border-radius:var(--border-radius-def)}.c0f43bf64{width:100%;border-spacing:0;border-top:1px solid #ecf4f6}.c0f43bf64 thead tr:first-child td:first-child{position:-webkit-sticky;position:sticky;left:0;z-index:2}.c0f43bf64 thead tr:first-child td:first-child{border-left:1px solid #ecf4f6}.c0f43bf64 thead tr:first-child td:first-child{border-radius:var(--border-radius-def) 0 0 0}.c0f43bf64 thead tr:first-child td:last-child{border-radius:0 var(--border-radius-def) 0 0}.c0f43bf64 thead tr td:last-child{border-right:1px solid #ecf4f6}.c0f43bf64 thead td{background:var(--color-flomni-gray-10);text-align:left;font-size:.875rem;font-weight:700;line-height:1rem;color:var(--color-flomni-gray-90);padding:.75rem 0 .75rem 1.5625rem;box-sizing:border-box;border-bottom:1px solid #ecf4f6}.c0f43bf64 thead td:last-child{padding-right:1.5625rem}.c0f43bf64 tbody td:first-child{position:-webkit-sticky;position:sticky;left:0;z-index:2}.c0f43bf64 tbody tr:last-child td:first-child{border-radius:0 0 0 var(--border-radius-def)}.c0f43bf64 tbody tr:last-child td:last-child{border-radius:0 0 var(--border-radius-def) 0}.c0f43bf64 tbody td{background:#fff;font-size:.875rem;font-weight:400;line-height:1rem;color:var(--color-flomni-gray-90);padding:.75rem 0 .75rem 1.5625rem;box-sizing:border-box}.c0f43bf64 tbody td:last-child{padding-right:1.5625rem;border-right:1px solid #ecf4f6}.c0f43bf64 tbody tr td{border-bottom:1px solid #ecf4f6}.c0f43bf64 tbody tr td:first-child{border-left:1px solid #ecf4f6}.c74b6d7d6 thead td:last-child{position:-webkit-sticky;position:sticky;right:0;z-index:1}.c74b6d7d6 tbody td:last-child{position:-webkit-sticky;position:sticky;right:0;z-index:1}");
var styles = {
  root: 'cffcb3f50',
  table: 'c0f43bf64',
  '--with-total': 'c74b6d7d6'
};

var DataTable = function DataTable(props) {
  var children = props.children,
      classes = props.classes,
      isTotal = props.isTotal;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, (0, _defineProperty2.default)({}, cn.with.total, isTotal))
  }, /*#__PURE__*/_react.default.createElement("table", {
    className: cn.table
  }, children));
};

exports.DataTable = DataTable;
DataTable.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,
  isTotal: _propTypes.bool,

  /* styling modificators */

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
DataTable.defaultProps = {
  isTotal: true,
  classes: {}
};